import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-elasticstack',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Elastic Stack icon</title><path d="M1.875 0C.839 0 0 .84 0 1.875v4.792h24V1.875C24 .839 23.16 0 22.125 0zM0 8.889v6.222h24V8.89zm0 8.444v4.792C0 23.161.84 24 1.875 24h9v-6.667zm13.125 0V24h9C23.161 24 24 23.16 24 22.125v-4.792z"/></svg>`,
    styles: []
})
export class SimpleIconsElasticstackComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#005571';
    @Input() className: string = 'simple-icons-elasticstack'
    constructor() {}
    ngOnInit(): void {}
}
